import * as React from "react";

function SvgCode({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M16 2.25A5.75 5.75 0 0121.75 8v8A5.75 5.75 0 0116 21.75H8A5.75 5.75 0 012.25 16V8A5.75 5.75 0 018 2.25zm0 1.5H8A4.25 4.25 0 003.75 8v8A4.25 4.25 0 008 20.25h8A4.25 4.25 0 0020.25 16V8A4.25 4.25 0 0016 3.75zm-3.023 4.527a.75.75 0 01.542.824l-.02.1-1.667 6a.75.75 0 01-1.466-.302l.02-.1 1.667-6a.75.75 0 01.924-.522zM9.53 9.47a.75.75 0 01.073.976l-.073.084L8.061 12l1.47 1.47a.75.75 0 01.072.976l-.073.084a.75.75 0 01-.976.073l-.084-.073-2-2a.75.75 0 01-.073-.976l.073-.084 2-2a.749.749 0 011.06 0zm5.916-.073l.084.073 2 2a.75.75 0 01.073.976l-.073.084-2 2a.749.749 0 01-1.133-.976l.073-.084L15.939 12l-1.47-1.47a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073z"
        />
      </g>
    </svg>
  );
}

export default SvgCode;
